export {Favicon} from './favicon'
